// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Paper, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding:   theme.spacing(1),
    textAlign: 'center',
    color:     theme.palette.text.secondary,
    width:     '100%',
  },
}));

const GridList = ({ value, children }) => {
  const classes = useStyles();
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: value.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position:  'relative',
  };

  return (
    <div style={style}>
      <div ref={setNodeRef} {...attributes} {...listeners}>
        <div className={classes.root} xs={6}>
          <Grid container item xs={6} style={{ marginBottom: 10 }}>
            <>
              <Grid item xs={12}>
                <Paper className={classes.paper} elevation={3}>
                  <div className="row flex-row align-items-center justify-content-space-around">
                    <div className="col-md-10 d-flex ml-2">
                      <Typography variant="h6" className="pl-2">
                        {value.name}
                      </Typography>
                    </div>
                  </div>
                </Paper>
              </Grid>
            </>
          </Grid>
        </div>
      </div>
      <div style={{ position: 'absolute', top: '18%', right: '26%' }}>
        {children}
      </div>
    </div>
  );
};

GridList.propTypes = {
  value:    PropTypes.shape(Object).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf([PropTypes.node]),
    PropTypes.node,
  ]).isRequired,
};

export default GridList;
